import loaderIcon from "components/common/icons/loader-animation.svg";
import { CircleCheck, Info, OctagonAlert, TriangleAlert } from "lucide-react";
import {ICON_SIZE} from "components/common/constants";
import { IInlineLoaderComponent } from "types/gaiaComponents/loader";
import { Tooltip } from "components/tooltip/Tooltip";

export enum InlineLoaderState {
    Active = 'active',
    Completed = 'completed',
    Error = 'error',
    Info = 'info',
    Warning = 'warning',
    Inactive = 'inactive'
}


export const InlineLoader = (props: IInlineLoaderComponent) => {
    const renderIcon = () => {
        switch (props.state) {
            case InlineLoaderState.Active:
                return (
                    <img
                        src={loaderIcon}
                        alt="Loading"
                        className="ga-inline-loading__icon"
                    />
                );
            case InlineLoaderState.Completed:
                return (
                    <CircleCheck
                        size={ICON_SIZE.SMALL}
                        className="ga-inline-loading__icon"
                    />
                );
            case InlineLoaderState.Error:
                return (
                    <OctagonAlert
                        size={ICON_SIZE.SMALL}
                        className="ga-inline-loading__icon"
                    />
                );
            case InlineLoaderState.Info:
                return (
                    <Info
                        size={ICON_SIZE.SMALL}
                        className="ga-inline-loading__icon"
                    />
                );
            case InlineLoaderState.Warning:
                return (
                    <TriangleAlert
                        size={ICON_SIZE.SMALL}
                        className="ga-inline-loading__icon"
                    />
                );
            case InlineLoaderState.Inactive:
            default:
                return null;
        }
    };

    const icon = renderIcon();
    // ITooltip allows id/content to be omitted, but react-tooltip needs both to bind a trigger
    // to its tooltip - rendering with an undefined id would break targeting. Only wrap when both
    // are present.
    const tooltip = props.tooltip;
    const iconWithTooltip = icon && tooltip?.id && tooltip.content ? (
        <>
            <span className="cursor-pointer" data-for={tooltip.id} data-tip="">
                {icon}
            </span>
            <Tooltip
                id={tooltip.id}
                place={tooltip.place}
                content={tooltip.content}
            />
        </>
    ) : icon;

    return (
        <div
            className={`ga-inline-loading ga-inline-loading--${props.state}`}
            data-cy={props.dataCy}
        >
            {iconWithTooltip}
            <span>{props.text}</span>
        </div>
    );
};

InlineLoader.displayName = "InlineLoader";

